import { render } from "./roomCardNew.vue?vue&type=template&id=b66c6dd4&scoped=true"
import script from "./roomCardNew.vue?vue&type=script&lang=js"
export * from "./roomCardNew.vue?vue&type=script&lang=js"

import "./roomCardNew.vue?vue&type=style&index=0&id=b66c6dd4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b66c6dd4"]])

export default __exports__